import Sidebar from 'src/components/ui/sidebar';
import { ContentTable } from './ContentTable/ContentTable';

export const ContentPage = () => {
  return (
    <Sidebar>
      <ContentTable />
    </Sidebar>
  );
};
